'use strict';

var d3 = require('d3');
var Scales = function Scales(params, data, mode) {
  var xRange = [330, 0],
    yRange = [0, 0];
  var xAxisRange = [0, params.width];
  var yAxisRange = [params.height, 0];
  function adjustRange(newRange, oldRange) {
    newRange[0] = Math.min(newRange[0], oldRange[0]);
    newRange[1] = Math.max(newRange[1], oldRange[1]);
  }
  data.forEach(function (c) {
    adjustRange(xRange, d3.extent(c.curveData, function (d) {
      return d.dtd;
    }));
    adjustRange(yRange, d3.extent(c.curveData, function (d) {
      return d.value;
    }));
  });
  if (mode === 'right-to-left') {
    xAxisRange = xAxisRange.reverse();
  }
  var x = d3.scale.linear().domain(xRange).range(xAxisRange);
  var y = d3.scale.linear().domain(yRange).range(yAxisRange);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;